import React from "react";
import "./ScrollCard.css";
import { useTheme } from "@mui/material";
import styled from "styled-components";
import { H1 } from "../../../../Assets/Styles/GlobleStyles/TextStyles";

export default function ScrollCard() {
  const theme = useTheme();

  const Title = styled(H1)`
  font-size: 65px;
  line-height: 112.4%;
  text-align: center;
  color: var(--radium-info-600);
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  margin: 0 auto;

  span {
    color: var(--blue-color-400);
  }

  @media (max-width: 1100px) {
    font-size: 45px;
  }
  @media (max-width: 975px) {
    font-size: 40px;
    line-height: 40px;
  }
  @media (max-width: 895px) {
    font-size: 38px;
  }
  @media (max-width: 855px) {
    letter-spacing: -0.01em;
    font-size: 35px;
  }
  @media (max-width: 715px) {
    font-size: 30px;
  }
`;

    const insights = [
        {
            value: "5",
            unit: "million",
            description: "Memberships",
            icon: "👥",
        },
        {
            value: "93",
            unit: "countries",
            description: "Global Reach",
            icon: "🌍",
        },
        {
            value: "20%",
            unit: "reduction",
            description: "in unnecessary testing",
            icon: "📊",
        },
        {
            value: "72%",
            unit: "Of",
            description: "Smartphone Users",
            icon: "📱",
        }
    ];

    return (
        <div>
          <Title>
              <b><span>Key</span> Insights</b>
            </Title>
            <div className="insights-container">
                {/* Animated background elements */}
                <div className="animated-bg">
                    <div className="floating-shape shape-1"></div>
                    <div className="floating-shape shape-2"></div>
                    <div className="floating-shape shape-3"></div>
                    <div className="floating-shape shape-4"></div>
                    <div className="floating-shape shape-5"></div>
                    <div className="particle-field"></div>
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                </div>
            
        
                <div className="insights-grid">
                    {insights.map((insight, index) => (
                        <div 
                            key={index} 
                            className="insight-card" 
                            style={{
                                "--card-gradient": `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                "--card-border": `${theme.palette.primary.main}`,
                            }}
                        >
                            <div className="card-background"></div>
                            <div className="insight-icon">{insight.icon}</div>
                            <div className="insight-content">
                                <h3 className="insight-value">
                                    {insight.value}
                                    <span className="insight-unit"> {insight.unit}</span>
                                </h3>
                                <p className="insight-description">{insight.description}</p>
                            </div>
                            {/* <div className="card-border"></div> */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}